module.exports = __webpack_public_path__ + "static/media/icono_corazon_lleno.76535c1b.svg";